export default function ShootingStarsBg() {
	return (
		// biome-ignore lint/a11y/noSvgWithoutTitle: <explanation>
		<svg viewBox="0 0 692 126" fill="none" xmlns="http://www.w3.org/2000/svg">
			<g opacity="0.2">
				<path
					d="M703.97 12.7401L555.776 40.0764L703.418 10.0735L703.97 12.7401Z"
					fill="#FBFBFB"
				/>
				<path
					d="M54.3984 155.771L114.32 105.493L55.3303 156.834L54.3984 155.771Z"
					fill="#FBFBFB"
				/>
				<path
					d="M64.9258 105.168L101.13 83.7473L65.3271 105.814L64.9258 105.168Z"
					fill="#FBFBFB"
				/>
				<path
					d="M-27.1262 74.7578L31.9253 71.6249L-27.0464 75.8234L-27.1262 74.7578Z"
					fill="#FBFBFB"
				/>
				<path
					d="M-20.2598 98.613L35.9769 80.3283L-19.9073 99.6218L-20.2598 98.613Z"
					fill="#FBFBFB"
				/>
				<path
					d="M537.694 126.07L500.055 107.284L538.019 125.382L537.694 126.07Z"
					fill="#FBFBFB"
				/>
			</g>
		</svg>
	);
}
